import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HorizontalListData, parseNumber } from 'common';
import { BankWidgetAdapter } from './bank-widget.data';
import { EntityFacade } from '../../entity/domain/+state/entity.facade';
import {
  BankBrandingByName,
  bankLinkStatusLabels,
  bankLogoExists,
  FinancialInstitution,
  getBankLogo,
  InstitutionIntegrationStatus,
} from '../bank-account.model';
import { BankingService } from '../banking.service';

@UntilDestroy()
@Component({
    selector: 'ifp-bank-widget',
    templateUrl: './bank-widget.component.html',
    styleUrls: ['./bank-widget.component.scss'],
    providers: [BankWidgetAdapter],
    standalone: false
})
export class BankWidgetComponent implements OnInit, OnChanges {
  @Input()
  institution: FinancialInstitution;

  institutionIntegrationStatus: number;
  brandingData = null;
  logoExists = false;
  logoSrc = null;
  color = null;
  private entityId: number;

  listItems: HorizontalListData[];

  readonly bankLinkStatusLabels = bankLinkStatusLabels;
  readonly InstitutionIntegrationStatus = InstitutionIntegrationStatus;

  constructor(
    private readonly bankingService: BankingService,
    private readonly entityFacade: EntityFacade,
    private readonly route: ActivatedRoute,
    private readonly adapter: BankWidgetAdapter,
  ) {}

  ngOnInit(): void {
    this.initEntity();
    this.institutionIntegrationStatus = this.institution.isLinked
      ? InstitutionIntegrationStatus.Linked
      : InstitutionIntegrationStatus.Unlinked;

    this.brandingData = BankBrandingByName[this.institution.institutionName];
    this.logoExists = bankLogoExists(this.institution.institutionName);

    if (this.logoExists) {
      this.logoSrc = getBankLogo(this.institution.institutionName);
      this.color = this.brandingData.color;
    }
  }

  ngOnChanges(): void {
    this.listItems = this.adapter.adaptListData(this.institution);
  }

  private initEntity(): void {
    this.entityFacade
      .getEntity$(parseNumber(this.route.snapshot.queryParams.companyId))
      .pipe(untilDestroyed(this))
      .subscribe((entity) => {
        this.entityId = entity.id;
      });
  }

  relink(): void {
    this.bankingService.relink(this.entityId, this.institution);
  }
}
